import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttLabelDate } from '../../../../sporttia/all';
import { Game } from '../../../../types/models/Game';

interface DetailsProps {
    game: Game;
}

export default function Details({ game }: DetailsProps) {
    const { t } = useTranslation();

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle2" color="textSecondary">
                    {t('Center')}
                </Typography>
                <Typography variant="body1">
                    {game.facility?.sc?.name || ''}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle2" color="textSecondary">
                    {t('Field')}
                </Typography>
                <Typography variant="body1">
                    {game.facility?.name || ''}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle2" color="textSecondary">
                    {t('Date')}
                </Typography>
                <Typography variant="body1">
                    <SttLabelDate date={game.ini} />
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle2" color="textSecondary">
                    {t('Time')}
                </Typography>
                <Typography variant="body1">
                    {game.ini?.slice(11, 16)} - {game.end?.slice(11, 16)}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle2" color="textSecondary">
                    {t('Level')}
                </Typography>
                <Typography variant="body1">{game.level}</Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle2" color="textSecondary">
                    {t('Gender')}
                </Typography>
                <Typography variant="body1">{t(`G.${game.gender}`)}</Typography>
            </Grid>
        </Grid>
    );
}
